import { Grid } from "@mui/material";
import Spinner from "components/Spinner";

/**
 * A functional React component that displays a loading indicator when the `loading` prop is true.
 *
 * @param {Object} props - The props object for the component.
 * @param {boolean} props.loading - A boolean flag indicating whether the loading indicator should be displayed.
 *
 * @returns {JSX.Element | null} - Returns a JSX element containing a centered spinner if `loading` is true,
 * or `null` if `loading` is false.
 */
const LoadingIndicator = ({ loading }: { loading: boolean }) => {
  if (!loading) return null;

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height: "100vh" }}
    >
      <Spinner size={80} data-testid="spinner" />
    </Grid>
  );
};

export default LoadingIndicator;
